const XMaskIcon = (props) => {
  const { size = 24, color, stroke, onClick } = props;
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      fill={color || "none"}
      stroke={stroke || "currentColor"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      className="w-6 h-6"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
};

export default XMaskIcon;
